(function () {

  angular
    .module('meanApp')
    .directive('tag', tag);

    tag.$inject = ['$compile'];
    function tag ($compile) {
        return {
            restrict: 'A',
            templateUrl: '/common/directives/tag/tag.template.html',
            controller: 'tagCtrl as that',
            scope: {
                tag : '@',
                almostTag : '@'
            },
            link : function(scope, element, attrs) {
                element[0].className='pricetag '+ attrs.tag + (attrs.almostTag == 'true' ? ' is-almost-tag' : '');
                //element[0].setAttribute('hm-press', 'that.onTagPressed('+attrs.tag+')');
                //$compile(element)(scope);
            }
        };
    }

})();